module.exports = __webpack_public_path__ + "static/media/47.caa58079.jpg";